import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../styles/Sidebar.css';

function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const menuItems = [
    {
      path: '/dashboard',
      icon: '📊',
      label: 'Dashboard'
    },
    {
      path: '/send-zns',
      icon: '📱',
      label: 'Gửi ZNS đơn lẻ'
    },
    {
      path: '/send-bulk-zns',
      icon: '📤',
      label: 'Gửi hàng loạt'
    },
    {
      path: '/templates',
      icon: '📝',
      label: 'Quản lý Template'
    }
  ];

  const user = JSON.parse(localStorage.getItem('user') || '{}');

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <div className="logo">
          <span className="logo-icon">N</span>
        </div>
        <h2>ZNS System</h2>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map(item => (
          <Link
            key={item.path}
            to={item.path}
            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </Link>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="user-info">
          <div className="user-avatar">
            {user.username?.charAt(0).toUpperCase() || 'A'}
          </div>
          <div className="user-details">
            <div className="user-name">{user.username || 'Administrator'}</div>
            <div className="user-role">{user.role === 'admin' ? 'Quản trị viên' : 'Người dùng'}</div>
          </div>
        </div>
        <button className="logout-btn" onClick={handleLogout}>
          Đăng xuất
        </button>
      </div>
    </div>
  );
}

export default Sidebar;
